import { UploadOutlined } from "@ant-design/icons";
import {
  Button,
  Card,
  Col,
  ConfigProvider,
  Flex,
  Row,
  Typography,
  Upload,
  message,
} from "antd";
import { useState } from "react";
import useApi from "../../utils/useApi";

const { Text } = Typography;

export default function Config() {
  const [collectionsFile, setCollectionsFile] = useState(null);
  const [zonesFile, setZonesFile] = useState(null);
  const [loadingButton, setLoadingButton] = useState(false);

  const { postCollectionsZonesCameras } = useApi();

  const collectionsProps = {
    name: "post_file",
    customRequest: ({ file, onSuccess }) => {
      setCollectionsFile(file);
      onSuccess("ok");
    },
    onChange(info) {
      if (info.file.status === "error") {
        message.error(`${info.file.name} file upload failed.`);
      }
    },
    fileList: collectionsFile ? [{ name: collectionsFile.name }] : [],
  };

  const zonesProps = {
    name: "post_file",
    customRequest: ({ file, onSuccess }) => {
      setZonesFile(file);
      onSuccess("ok");
    },
    onChange(info) {
      if (info.file.status === "error") {
        message.error(`${info.file.name} file upload failed.`);
      }
    },
    fileList: zonesFile ? [{ name: zonesFile.name }] : [],
  };

  const handleFiles = () => {
    setLoadingButton(true);
    postCollectionsZonesCameras(collectionsFile, zonesFile)
      .then(() => {
        message.success("Arquivos enviados com sucesso!");
        setZonesFile(null);
        setCollectionsFile(null);
      })
      .catch((error) => {
        message.error(`Erro ao enviar arquivos: ${error}`);
      })
      .finally(() => {
        setLoadingButton(false);
      });
  };

  return (
    <>
      <ConfigProvider
        theme={{
          components: {
            Card: {
              headerBg: "#d0d6e2",
            },
          },
        }}>
        <Flex
          style={{ width: "100%" }}
          justify="center"
          align="center"
          vertical
          gap={50}>
          <Card title="Adicione seus arquivos de configuração">
            <Row gutter={[16, 16]}>
              <Col span={12} align="center">
                <Text>
                  Arquivo sobre <Text strong>coleções</Text>
                </Text>
              </Col>
              <Col span={12} align="center">
                <Text>
                  Arquivo sobre <Text strong>zonas</Text>
                </Text>
              </Col>
              <Col span={12} align="center">
                <Upload {...collectionsProps} maxCount={1} accept=".csv">
                  <Button
                    icon={<UploadOutlined />}
                    style={{ borderColor: zonesFile ? "green" : null }}>
                    Envie o arquivo CSV
                  </Button>
                </Upload>
              </Col>
              <Col span={12} align="center">
                <Upload {...zonesProps} maxCount={1} accept=".csv">
                  <Button
                    icon={<UploadOutlined />}
                    style={{ borderColor: zonesFile ? "green" : null }}>
                    Envie o arquivo CSV
                  </Button>
                </Upload>
              </Col>
              <Col span={24} align="center">
                <Button
                  type="primary"
                  loading={loadingButton}
                  onClick={handleFiles}>
                  Enviar
                </Button>
              </Col>
            </Row>
          </Card>
        </Flex>
      </ConfigProvider>
    </>
  );
}
